import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const RecommendationText = styled.span`
  font-size: ${tokens.fontSize.medium};
  color: ${tokens.colors.dark5};
  font-weight: ${tokens.fontWeights.bold};
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${tokens.spacing.verticalSmall};
  margin-top: auto;
`

export const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.verticalLarge};
`

export const ReadingGoalTimeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${tokens.spacing.horizontalSmall};
  justify-content: center;
`

export const RecommendationExplanation = styled.span`
  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark4};
  font-weight: ${tokens.fontWeights.bold};
`

export const DownloadGuideLink = styled.span`
  cursor: pointer;
  color: ${tokens.colors.dark5};
  text-decoration: underline;
`

export const RoundButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: ${tokens.radius.circular};
  background-color: ${tokens.colors.white};
  border: 1px solid ${tokens.colors.dark4};
  cursor: pointer;
`

export const RoundButtonText = styled.span`
  font-size: ${tokens.fontSize.xxxlarge};
  color: ${tokens.colors.dark5};
  line-height: 25px;
`

export const MinutesSelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalSmall};
`

export const MinutesSelectionText = styled.span`
  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark4};
  font-weight: ${tokens.fontWeights.bold};
`

export const TimeInput = styled.input`
  background-color: ${tokens.colors.white};
  border: none;
  font-size: ${tokens.fontSize.xxxlarge};
  color: ${tokens.colors.dark5};
  text-align: center;
  font-weight: ${tokens.fontWeights.bold};
  margin-left: 15px;
`
